export const Drop = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1673 12.3258C14.1673 10.3287 13.3634 8.31242 10.0027 3.88275C6.64041 8.29718 5.83398 9.94253 5.83398 12.3258C5.83398 14.4398 7.64489 16.25 10.0007 16.25C12.3564 16.25 14.1673 14.4398 14.1673 12.3258ZM15.4173 12.3258C15.4173 9.84824 14.3447 7.5086 10.8401 2.91897C10.4121 2.35854 9.59223 2.36132 9.16394 2.92146C5.68041 7.47733 4.58398 9.44076 4.58398 12.3258C4.58398 15.1835 7.00911 17.5 10.0007 17.5C12.9922 17.5 15.4173 15.1835 15.4173 12.3258ZM11.8757 11.6675C11.8757 12.0152 11.6899 12.4962 11.3239 12.8988C10.9655 13.2931 10.4982 13.5425 10.0007 13.5425V14.7925C10.9317 14.7925 11.7144 14.3276 12.2488 13.7397C12.7757 13.1602 13.1257 12.3912 13.1257 11.6675H11.8757Z"
        fill="#B5B7C0"
      />
    </svg>
  );
};
